// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__3IWZw","inner":"Form_inner__1WT0x","range":"Form_range__3EvX2","name":"Form_name__1H2dk","actions":"Form_actions__rRcqW"};